import * as tslib_1 from "tslib";
import { Apollo } from 'apollo-angular';
import { Queries } from './graphql/queries';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
import * as i2 from "./graphql/queries";
var DeadlineCotractApi = /** @class */ (function () {
    function DeadlineCotractApi(apollo, queries) {
        this.apollo = apollo;
        this.queries = queries;
    }
    DeadlineCotractApi.prototype.getDeadlineContractByConfig = function (_a) {
        var locationId = _a.locationId, segmentId = _a.segmentId, maintenanceTypeId = _a.maintenanceTypeId;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_b) {
                return [2 /*return*/, this.apollo
                        .query({
                        query: this.queries.deadlineContractByConfig(),
                        variables: { locationId: locationId, maintenanceTypeId: maintenanceTypeId, segmentId: segmentId }
                    })
                        .toPromise()
                        .then(function (_a) {
                        var data = _a.data;
                        return data['deadlineContractByConfig'];
                    })];
            });
        });
    };
    DeadlineCotractApi.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DeadlineCotractApi_Factory() { return new DeadlineCotractApi(i0.ɵɵinject(i1.Apollo), i0.ɵɵinject(i2.Queries)); }, token: DeadlineCotractApi, providedIn: "root" });
    return DeadlineCotractApi;
}());
export { DeadlineCotractApi };
